import { TableRow } from "@mui/material";
import ScannerInputActionBox from "../../ScannerInputActionBox/ScannerInputActionBox";
import * as Styles from "../CustomTable.styles";
import CustomIcon from "../../CustomIcon/CustomIcon";
import { ElementType } from "react";
import { SvgIconComponent } from "@mui/icons-material";
import { CustomButton } from "../../CustomButton/CustomButton";
import DeleteSweepRoundedIcon from "@mui/icons-material/DeleteSweepRounded";
import HoverToolTip from "../../ToolTips/HoverToolTip/HoverToolTip";

interface CustomTableHeaderProps {
  tableTitle: string;
  TableIcon: ElementType | SvgIconComponent;
  isScanMode: boolean;
  showRemoveColumn: boolean;
  tableColumnsTotal: number;
  onResetScanner?: () => void;
}

interface TableHeaderColumn {
  label: string;
  align: "left" | "center";
}

const DEFAULT_COLUMNS: TableHeaderColumn[] = [
  { label: "Código", align: "left" },
  { label: "Cód. barras", align: "left" },
  { label: "Nome", align: "center" },
  { label: "Medida", align: "center" },
  { label: "Quantidade", align: "center" },
  { label: "", align: "center" },
];

export default function CustomTableHeader({
  TableIcon,
  isScanMode,
  showRemoveColumn,
  tableColumnsTotal,
  tableTitle,
  onResetScanner,
}: CustomTableHeaderProps) {
  return (
    <Styles.CustomTableHead>
      <Styles.HeaderTitleRow>
        <Styles.HeaderTitleCell colSpan={showRemoveColumn ? 8 : 7}>
          <Styles.HeaderTitleContent>
            <span>{tableTitle}</span>
            <Styles.HeaderTitleContentIcon>
              {<CustomIcon Icon={TableIcon} size="var(--icon-size-2xl)" color="currentColor" />}
            </Styles.HeaderTitleContentIcon>
          </Styles.HeaderTitleContent>
        </Styles.HeaderTitleCell>
      </Styles.HeaderTitleRow>

      <Styles.HeaderColumnsRow>
        {DEFAULT_COLUMNS.map((column, index) => (
          <Styles.CustomHeaderCell key={index} align={column.align}>
            {column.label}
          </Styles.CustomHeaderCell>
        ))}

        {showRemoveColumn && <Styles.CustomHeaderCell />}
      </Styles.HeaderColumnsRow>

      {isScanMode && (
        <TableRow>
          <Styles.ScannerCell colSpan={tableColumnsTotal}>
            <Styles.ScannerCellContent>
              <ScannerInputActionBox />
              <HoverToolTip content={"Limpar leitor"}>
                <CustomButton
                  backgroundColor="var(--color-background-surface)"
                  hoverBackgroundColor="var(--color-background-field-hover)"
                  textColor="var(--color-text-primary)"
                  hoverTextColor="var(--color-action-danger)"
                  onClick={onResetScanner}
                >
                  <CustomIcon Icon={DeleteSweepRoundedIcon} color="currentColor" size="1.6rem" />
                </CustomButton>
              </HoverToolTip>
            </Styles.ScannerCellContent>
          </Styles.ScannerCell>
        </TableRow>
      )}
    </Styles.CustomTableHead>
  );
}
